module.exports = __webpack_public_path__ + "img/profile-pic-meeting.dcdd1ff8.jpg";